import React, { FC } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

interface WithNameProps {
  [index: string]: string;
}

const withName = (type: string, idName: string) => (WrappedComponent: FC<WithNameProps>) => {
  const WithName = (props: WithNameProps) => {
    const { name, [idName]: id } = props;
    const resolvedName = (typeof name !== 'undefined') ? String(name) : `${type}${id}`;
    return <WrappedComponent {...props} name={resolvedName} />;
  };

  WithName.displayName = getWrappedDisplayName('WithName', WrappedComponent);

  return hoistNonReactStatics(WithName, WrappedComponent);
};

export default withName;
